import { PaginatedResponse } from "../role.repository";
import { apiClient } from "../../client";

export interface StoreFormat {
    id: number;
    tenant_id: number;
    en_name: string;
    ar_name?: string | null;
    status: number;
    created_by?: number;
    updated_by?: number;
    created_at: number;
    updated_at: number;
}

export interface CreateStoreFormatRequest {
    tenant_id: number;
    en_name: string;
    ar_name?: string;
    status?: number;
}

export interface UpdateStoreFormatRequest {
    tenanat_id?: number;
    en_name?: string;
    ar_name?: string;
    status?: number;
}


class StoreFormatRepository {

    async getAll(page: number = 1, limit: number = 10, filters?: any): Promise<PaginatedResponse<StoreFormat>> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filters.search) {
            params.append('search', filters.search);
        }

        if (filters.status) {
            params.append('status', filters.status);
        }

        if (filters.store_format_id) {
            params.append('store_format_id', filters.store_format_id)
        }

        return apiClient.get<PaginatedResponse<StoreFormat>>(`/store-formats?${params.toString()}`);

    }

    async getById(id: number): Promise<StoreFormat> {

        return apiClient.get<StoreFormat>(`/store-formats/${id}`);

    }

    async create(data: CreateStoreFormatRequest): Promise<StoreFormat> {
        return apiClient.post<StoreFormat>(`/store-formats`, data);

    }

    async update(id: number, data: UpdateStoreFormatRequest): Promise<StoreFormat> {
        return apiClient.put<StoreFormat>(`/store-formats/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/store-formats/${id}`);
    }

    async exportToExcel(filters?: any): Promise<Blob> {

        const params = new URLSearchParams();

        if (filters?.search) {
            params.append('search', filters.search);
        }

        if (filters?.status) {
            params.append('status', filters.status);
        }

        if (filters?.store_format_id) {
            params.append('store_format_id', filters.store_format_id.toString())
        }

        const baseUrl = `/store-formats/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }

}

export const storeFormatRepository = new StoreFormatRepository();